import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  public closeButtonClicked = new Subject<void>()

  closeButtonClicked$ = this.closeButtonClicked.asObservable()

  emitCloseButtonClick(): void {
    this.closeButtonClicked.next()
  }
}
